import { render, staticRenderFns } from "./EnquiryList.vue?vue&type=template&id=1919a866&scoped=true"
import script from "./EnquiryList.vue?vue&type=script&lang=js"
export * from "./EnquiryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919a866",
  null
  
)

export default component.exports